
(() => {
  let product = JSON.parse(document.getElementById('allure-product-json').textContent);
  const currency = JSON.parse(document.getElementById('allure-currency-json').textContent);
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  window.ALR_ADD_TO_CART = async (state, tier, colors) => {
    if (currency !== 'USD') throw new Error('Checkout is getting ready. Please check back shortly.');
    if (!product || !product.variants) {
      const response = await fetch(root + 'products/crisscross-tummy-shaper.js', {headers: {'Accept': 'application/json'}});
      if (!response.ok) throw new Error('Checkout is getting ready. Please check back shortly.');
      product = await response.json();
    }
    if (!product.variants) throw new Error('Checkout is getting ready. Please check back shortly.');
    const counts = new Map();
    for (let i=0;i<tier.qty;i++) {
      const color=colors[state.colors[i]][0], size=state.sizes[i];
      const variant=product.variants.find(v=>v.option1===color && v.option2===size && v.available);
      if (!variant) throw new Error('That size or color is unavailable. Please choose another.');
      if (variant.price !== 3990) throw new Error('This offer is temporarily unavailable. Please check back shortly.');
      counts.set(variant.id,(counts.get(variant.id)||0)+1);
    }
    const lines=[...counts].map(([id,quantity])=>id+':'+quantity).join(',');
    location.assign(root+'cart/'+lines);
  };
})();
